import { Flex } from "@rebass/grid/emotion"
import styled from "@emotion/styled"

export const TabsBox = styled(Flex)`
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  @media (min-width: 1280px) {
    flex-direction: column;
  }

  button {
    width: 33%;
    max-width: 96px;
    height: 34px;
    padding: 0 12px;

    @media (min-width: 768px) {
      max-width: 120px;
      height: 42px;
    }
    @media (min-width: 1280px) {
      padding: 0 24px;
      width: 100%;
      height: 56px;
      max-width: 171px;
    }

    border-radius: 4px;
    background-color: #ffffff;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #f6b615;
    }

    &:active {
      background-color: #041c1b;

      .textelement.nova.text-nova-transparency-black-60 {
        color: #ffffff !important;
      }
    }

    &.selected {
      background-color: #ffc942;
      pointer-events: none;
      cursor: default;
    }
  }
`
